

<div class="container">
    <div class="title-container">
        <p class="instructions">Choose an assignment </p>
        <p class="lesson-name">{{lessonName}}</p>
        <p class="sub-instructions">You are attempting to open a lesson that is assigned to you multiple times. 
            <br> Click one of the boxes below to select the appropriate assignment.</p>
    </div>
   
    <div class="card-container">
        <mat-card class="student-assignment" *ngFor="let assignment of lessons" (click)="goToStudentAssignmentFromClick(assignment.AssignmentID)">
          
                <div class="card-title">
                    <div class="class-title"><u>{{assignment.ClassName}}</u></div>
                
                    <div class="class-desc">{{assignment.ClassDesc}}</div>
                </div>
        
                <mat-card-subtitle>
                    {{assignment.TeacherFullName}}
                </mat-card-subtitle>
         
            
    
            <mat-card-content>
                Start date: {{assignment.StartDate}}
                <br><br>
                Due date: {{assignment.DueDate}}
            </mat-card-content>
            <mat-card-footer>
               
            </mat-card-footer>
        </mat-card>
    </div>
    
</div>
